import { sixDigits } from 'Data/validate.js'
import { useDataValue } from 'Simple/Data'

export function useDisabled(props) {
  let selected = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
  })
  let current_location_xid = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.xid',
  })

  if (!selected.location_id) return true
  if (current_location_xid === selected.xid) return false

  return !selected.mfa_token || !sixDigits(selected.mfa_token)
}
